// mui
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

// custom components
import { Text } from '../../../1elements'
import Link from '../../../1elements/Link'

const MultipleColumnsDataListView = ({ data, numberOfColumn }) => {
    const { label, isHidden, fieldData, position, type } = data
    const key = `${label}${position}`
    const hasURL = fieldData?.length > 1 && fieldData[2]?.length > 0
    const classes = useStyles({ numberOfColumn })

    const parseFieldData = (fieldData) => {
      if (!Boolean(fieldData)||fieldData === "null") return Array(numberOfColumn - 1).fill('')

        if (Array.isArray(fieldData)) return fieldData

        if (typeof fieldData !== "string")
        {
            return Array(numberOfColumn - 1).fill('')
        }
        
        try{
            return JSON.parse(fieldData)
        }catch(err)
        {
            console.log("Function MultipleColumnsDataListView returned data that could not be parsed to JSON " + err.message)
            console.log("fieldData = " + fieldData)
            return Array(numberOfColumn - 1).fill('')
        }
    }

    const parsedFieldData = parseFieldData(fieldData)

    const content = () => (
        <React.Fragment>
            <Text>{label}</Text>
            {
                parsedFieldData.map((data, index) => {
                    // The last data is URL
                    if (index === parsedFieldData.length - 1 && parsedFieldData.length > 1) {
                        return (
                            <Text key={index}>{data.length ? 'View Record' : 'No Record'}</Text>
                        )
                    }

                    if (type === 'Link' && parsedFieldData.length === 1) {
                      return (
                        <div key={index}>
                            <a href={data}>View</a>
                        </div>
                      )
                    }

                    return (
                        <Text key={index}>{data}</Text>
                    )
                })
            }
        </React.Fragment>
    )

    if (hasURL) {
        return (
            <Link key={key} href={fieldData[2]} className={`${classes.root} ${isHidden && classes.reorderInnerDivHidden} ${hasURL && classes.rootHover}`}>
                {content()}
            </Link>
        )
    }

    return (
        <div key={key} className={`${classes.root} ${isHidden && classes.reorderInnerDivHidden} ${hasURL && classes.rootHover}`}>
            {content()}
        </div>
    )
}

export default MultipleColumnsDataListView

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'grid',
        width: '100%',
        margin: '10px 0',
        gridTemplateColumns: props => `repeat(${props.numberOfColumn}, 1fr)`,
    },
    rootHover: {
        cursor: 'pointer',
        '&:hover *': {
            color: theme.palette.primary.accent
        }
    },
    textField: {
        width: 250,

        '& .MuiInputBase-input': {
            boxShadow: '0px 3px 6px #00000029',
            padding: '1px 3px'
        }
    },
    fieldLabelDiv: {
        display: 'flex',
        alignItems: 'center'
    },
    reorderInnerDivHidden: {
        '& .MuiFormControl-root': {
            opacity: .6,
        },
        '&>*': {
            boxShadow: 'none'
        }
    },
}))